import { createSelector } from 'reselect'

const getCurrencies = ({ currency }) => currency.records

const currencySelectors = {
  getCurrenciesOptions: createSelector([getCurrencies], (currencies) => {
    if (!currencies.length) {
      return []
    }

    return currencies.map(({ sortOrder, ...currency }) => ({
      label: currency.description,
      value: currency,
    }))
  }),
}

export default currencySelectors
